import { PiInfoLight } from 'react-icons/pi';
import Tooltip from 'src/modules/shared/components/atoms/tooltips/tooltip';

interface HelpTooltipProps {
  content: string;
}

export const HelpTooltip: React.FC<HelpTooltipProps> = ({ content }) => (
  <Tooltip content={content} placement="top" size="sm">
    <span className="inline-flex items-center text-primary-400 hover:text-primary-600 cursor-help">
      <PiInfoLight className="h-4 w-4" />
    </span>
  </Tooltip>
);
